import { IoIosLink,IoIosShareAlt } from "react-icons/io";
import { MdShare } from "react-icons/md";
const ShareButton = ({ title, text, url }) => {
    const handleShare = async () => {
      if (navigator.share) {
        try {
          await navigator.share({ 
            url,
          });
        
        } catch (error) {
        
        }
      } else {
      
      }
    };
  
    return<div title="Share" className="p-0" onClick={handleShare}><MdShare className='icon'/> </div>  ;
  };
  
  export default ShareButton;
  